import { Resource } from 'i18next';
import { State, Store } from 'store/types';
import i18n, { i18nConfig } from '../../../i18n.config';
import { Language } from '../cookies';
import { LOCALIZATION_EVENTS } from './localization-constants';
import { LocalizationData } from './localization-types';

/**
 * Экшен загрузки переводов
 * @param {string} lang
 * @param {string} [ns]
 * @returns {Promise<State>}
 */
export const loadResources = (lang: string, ns?: string) =>
  new Promise<LocalizationData>(resolve =>
    i18n
      .use({
        type: 'backend',
        read(
          language: Language,
          namespace: string,
          callback: (errorValue: unknown, translations: unknown) => void
        ) {
          if (namespace === 'translations' && ns) {
            import(`landings/${ns}/locales/${language}/translation.json`)
              .then(resources => {
                callback(null, resources.default);
              })
              .catch(error => {
                callback(error, null);
              });
          } else {
            import(`locales/${language}/${namespace}.json`)
              .then(resources => {
                callback(null, resources.default);
              })
              .catch(error => {
                callback(error, null);
              });
          }
        },
      })
      .init({ ...i18nConfig, lng: lang }, () => {
        const initialLanguage = i18n.languages[0];
        const initialI18nStore: Resource = {};

        i18n.languages.forEach(language => {
          initialI18nStore[language] = i18n.services.resourceStore.data[language];
        });

        resolve({
          initialI18nStore,
          initialLanguage,
        });
      })
  );

/**
 * Экшен загрузки переводов
 * @param {Store} store
 * @returns {Promise<State>}
 */
export const loadResourcesAction = (store: Store, ns: string | undefined) =>
  new Promise<State>(resolve => {
    store.dispatch(LOCALIZATION_EVENTS.init, { ns });

    const unsub = store.on('@dispatch', state => {
      if (state.localization?.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
